// extracted by mini-css-extract-plugin
export default {"navButton":"UserMenu_navButton__JEgl5","userMenuContainer":"UserMenu_userMenuContainer__1Eke0","loginLink":"UserMenu_loginLink__OE-6K"};